import { PROCESS } from "@/lib/mock";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-16 lg:py-24 bg-stone-50"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="max-w-3xl mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 text-xs font-semibold text-orange-600 mb-4">
            <span className="w-1.5 h-1.5 bg-orange-500 rounded-full" />
            HOW WE WORK
          </div>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.025em] text-stone-900">
            From first walk
            <br />
            <span className="text-stone-500">to the final sweep.</span>
          </h2>
        </div>

        {/* Horizontal step cards with connector line */}
        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute left-0 right-0 top-[88px] h-px bg-stone-200" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {PROCESS.map((p) => (
              <div
                key={p.n}
                data-testid={`process-step-${p.n}`}
                className="relative bg-white rounded-2xl p-7 border border-stone-200 hover:border-stone-900/20 hover:-translate-y-1 hover:shadow-[0_24px_50px_-20px_rgba(28,25,23,0.18)] transition-all duration-500"
              >
                <div className="relative w-14 h-14 bg-stone-900 rounded-full flex items-center justify-center text-stone-50 font-display text-lg font-semibold mb-6">
                  {p.n}
                  <span className="absolute inset-0 rounded-full ring-4 ring-orange-500/20" />
                </div>
                <h3 className="font-display font-semibold text-2xl text-stone-900 tracking-tight leading-tight mb-3">
                  {p.title}
                </h3>
                <p className="text-stone-600 leading-relaxed text-[15px]">
                  {p.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
